function gupLifestyleLoad () {
// const wait = (time) =>
//   new Promise((resolve, reject) => {
//     const waiter = setTimeout(() => {
//       resolve();
//     }, time);
// });
const state = { videoBannerExpanded: false };
// const videoBanner = document.querySelector(".video-banner video");
// const videoCursor = document.querySelector("#gup-video-cursor");
// const videoBannerImageOverlays = document.querySelectorAll(
  // ".gup-video-image-overlay"
// );
// const videoCursorMouseEnter = (e) => {
//   videoCursor.style.opacity = 1;
//   videoCursor.style.setProperty(
//     "--gup-video-cursor-offset-x",
//     e.clientX + 12 + "px"
//   );
//   videoCursor.style.setProperty(
//     "--gup-video-cursor-offset-y",
//     e.clientY + 8 + "px"
//   );
// };
// videoBanner.addEventListener("mouseenter", videoCursorMouseEnter);
// videoBannerImageOverlays.forEach((e) =>
//   e.addEventListener("mouseenter", videoCursorMouseEnter)
// );
// videoBanner.addEventListener("mousemove", videoCursorMouseEnter);
// videoBannerImageOverlays.forEach((e) =>
//   e.addEventListener("mousemove", videoCursorMouseEnter)
// );
// videoBanner.addEventListener("mouseleave", (e) => {
//   videoCursor.style.opacity = 0;
// });
// videoBannerImageOverlays.forEach((e) =>
//   e.addEventListener("mouseleave", (e) => {
//     videoCursor.style.opacity = 0;
//   })
// );
// videoBanner.parentElement.parentElement.addEventListener("click", (e) => {
//   if (!state.videoBannerExpanded) {
//     videoCursor.style.zIndex = "100000";
//     videoCursor.innerHTML = "CLOSE";
//     e.currentTarget.querySelector("video").style.position = "fixed";
//     e.currentTarget.querySelector("video").style.height = "100vh";
//     e.currentTarget.querySelector("video").style.width = "100vw";
//     state.videoBannerExpanded = getComputedStyle(e.currentTarget.querySelector("video")).transform;
//     e.currentTarget.querySelector("video").style.setProperty("transform", "none", "important");
//     // BUG: STILL SET WITH INITIAL VALUE WHEN CLICKED FIRST TIME AFTER SCROLL
//     e.currentTarget.querySelector("video").style.objectFit = "contain";
//     e.currentTarget.querySelector("video").controls = true;
//     // e.currentTarget.style.position = "fixed";
//     // e.currentTarget.style.width = "100%";
//     e.currentTarget.style.zIndex = "10000";
//     e.currentTarget.style.transform = "none";
//     // e.currentTarget.parentElement.style.height = "100vh";
//     document.querySelector("#MainContent").style.position = "fixed";
//     document.querySelector("#MainContent").style.zIndex = "10000";
//   } else {
//     videoCursor.style.zIndex = "";
//     videoCursor.innerHTML = "EXPAND";
//     e.currentTarget.querySelector("video").style.position = "absolute";
//     e.currentTarget.querySelector("video").controls = false;
//     e.currentTarget.querySelector("video").style.height = "100%";
//     e.currentTarget.querySelector("video").style.width = "100%";
//     e.currentTarget.querySelector("video").style.setProperty("transform", state.videoBannerExpanded);
//     state.videoBannerExpanded = false;
//     e.currentTarget.querySelector("video").style.objectFit = "cover";
//     // e.currentTarget.style.position = "relative";
//     // e.currentTarget.style.width = "auto";
//     e.currentTarget.style.zIndex = "";
//     e.currentTarget.style.transform = 
//       "translateY(var(--gup-home-video-parallax)) scale(1.2)";
//     // e.currentTarget.parentElement.style.height = "auto";
//     document.querySelector("#MainContent").style.position = "relative";
//     document.querySelector("#MainContent").style.zIndex = "";
//   }
// });
// const videoCursorImageOverlayClick = async (e) => {
//   e.stopPropagation();
//   const target = e.currentTarget;
//   const img = target.querySelector("img");
//   if (!img) return;
//   if (videoCursor.innerHTML === "EXPAND") {
//     if (
//       target.classList.contains("gup-video-image-overlay-4") &&
//       getComputedStyle(img).maxHeight !== "100%"
//     )
//     {
//       scroll({top: innerHeight + 2000});
//       await wait(750);
//     }
//     else if (
//       target.classList.contains("gup-video-image-overlay-5") &&
//       getComputedStyle(img).maxHeight !== "100%"
//     )
//     {
//       scroll({top: innerHeight + 3100});
//       await wait(750);
//     }
//     else if (
//       target.classList.contains("gup-video-image-overlay-6") &&
//       getComputedStyle(img).maxHeight !== "100%"
//     )
//     {
//       scroll({top: innerHeight + 4200});
//       await wait(750);
//     }
//     const side =
//       img.getBoundingClientRect().left < innerWidth / 2
//         ? "left"
//         : "right";
//     const isSquare = target.classList.contains("gup-video-image-overlay-4") || target.classList.contains("gup-video-image-overlay-5")  || target.classList.contains("gup-video-image-overlay-6");
//     const maxWidth = isSquare ? "100%" : img.getBoundingClientRect().width > img.getBoundingClientRect().height ? Math.abs(
//       img.getBoundingClientRect()[side] * 2 - innerWidth
//     ) : img.getBoundingClientRect().width * (innerHeight / img.getBoundingClientRect().height);
//     const translate = isSquare ? 0 :
//       (innerHeight / 2 -
//       (img.getBoundingClientRect().height *
//         (maxWidth / img.getBoundingClientRect().width)) /
//         2 -
//       img.getBoundingClientRect().y) - 20;
//     videoCursor.innerHTML = "CLOSE";
//     if(isSquare) {
//       img.style.setProperty("max-width", maxWidth, "important");
//     } else img.style.setProperty("max-width", `${maxWidth}px`, "important");
//     if(isSquare) {
//       img.style.setProperty("max-height", "100%");
//     } else if(img.getBoundingClientRect().width > img.getBoundingClientRect().height) {
//       img.style.setProperty("max-height", `${maxWidth}px`);
//     } else img.style.setProperty("max-height", "100vh")
//     img.style.setProperty("width", `100vw`, "important");
//     img.style.setProperty(
//       "transform",
//       `translateY(${translate}px)`,
//       "important"
//     );
//     img.parentElement.style.zIndex = 5;
//     img.setAttribute("eager", "eager");
//     const src = img.srcset.includes(",")
//       ? img.srcset.match(/,([^ ]+) [^ ]+$/)[1]
//       : img.srcset;
//     img.setAttribute("src", src);
//     img.setAttribute("srcset", src);
//     if (!img.parentElement.querySelector(".gup-escape")) return;
//     img.parentElement.querySelector(".gup-escape").style.display = "block";
//     if (!img.parentElement.querySelector(".gup-shadow")) return;
//     img.parentElement.querySelector(".gup-shadow").style.opacity = "0";
//     // if (!img.parentElement.querySelector(".gup-caption")) return;
//     // img.parentElement.querySelector(".gup-caption").style.opacity = "0";
//   } else {
//     const side = target.classList.contains("gup-video-image-overlay-2")
//       ? "left"
//       : "right";
//     videoCursor.innerHTML = "EXPAND";
//     img.style.setProperty("max-width", `100%`, "important");
//     img.style.setProperty("max-height", "100%");
//     img.style.setProperty("width", `100vw`, "important");
//     img.style.setProperty("transform", "");
//     img.parentElement.style.zIndex = target.classList.contains("gup-video-image-overlay-6") ? 5 : 1;
//     if (!img.parentElement.querySelector(".gup-escape")) return;
//     img.parentElement.querySelector(".gup-escape").style.display = "none";
//     setTimeout(() => {
//       if (!img.parentElement.querySelector(".gup-shadow")) return;
//       img.parentElement.querySelector(".gup-shadow").style.opacity = "1";
//       // if (!img.parentElement.querySelector(".gup-caption")) return;
//       // img.parentElement.querySelector(".gup-caption").style.opacity = "1";
//     }, 500);
//   }
// };
// videoBannerImageOverlays.forEach((e) =>
//   e.addEventListener("click", videoCursorImageOverlayClick)
// );

const tl = gsap.timeline();
tl.fromTo(
  "video",
  { filter: "blur(20px)" },
  { filter: "blur(0px)", duration: 1 }
);
tl.fromTo(
  ".gup-video-logo",
  { filter: "invert(1) blur(4px)" },
  { filter: "invert(1) blur(0px)", duration: 0.5 },
  ">-1"
);
tl.fromTo(
  ".gup-lifestyle-copy.gup-video-overlay-copy.gup-sticky-copy-2 .gup-line-1",
  { filter: "blur(20px)" },
  { filter: "blur(0px)", duration: 0.75 },
  ">+0.25"
);
tl.fromTo(
  ".gup-lifestyle-copy.gup-video-overlay-copy.gup-sticky-copy-2 .gup-line-2",
  { filter: "blur(20px)" },
  { filter: "blur(0px)", duration: 0.75 },
  ">-0.5"
);

gsap.registerPlugin(ScrollTrigger);

gsap.fromTo(
  ".gup-video-image-overlay-1",
  {
    // opacity: 0,
    display: "none",
  },
  {
    // opacity: 1,
    display: "flex",
    // duration: 1,
    scrollTrigger: {
      trigger: ".gup-video-image-overlay-1",
      start: "top bottom",
    },
  }
);
gsap.fromTo(
  ".gup-video-image-overlay-2",
  {
    // opacity: 0,
    display: "none",
  },
  {
    // opacity: 1,
    display: "flex",
    // duration: 1,
    scrollTrigger: {
      trigger: ".gup-video-image-overlay-2",
      start: "top bottom",
    },
  }
);
gsap.fromTo(
  ".gup-video-image-overlay-3",
  {
    // opacity: 0,
    display: "none",
  },
  {
    // opacity: 1,
    display: "flex",
    // duration: 1,
    scrollTrigger: {
      trigger: ".gup-video-image-overlay-3",
      start: "top bottom",
    },
  }
);
gsap.fromTo(
  ".gup-video-image-overlay-1",
  {
    filter: "blur(20px)",
  },
  {
    filter: "blur(0px)",
    duration: 0.3,
    scrollTrigger: {
      trigger: ".gup-video-image-overlay-1",
      start: "center bottom",
    },
  }
);
gsap.fromTo(
  ".gup-video-image-overlay-2",
  {
    filter: "blur(20px)",
  },
  {
    filter: "blur(0px)",
    duration: 0.3,
    scrollTrigger: {
      trigger: ".gup-video-image-overlay-2",
      start: "bottom bottom",
    },
  }
);
gsap.fromTo(
  ".gup-video-image-overlay-3",
  {
    filter: "blur(20px)",
  },
  {
    filter: "blur(0px)",
    duration: 0.1,
    scrollTrigger: {
      trigger: ".gup-video-image-overlay-3",
      start: "bottom bottom",
    },
  }
);
gsap.to(".gup-video-image-overlay-1", {
  y: 
    // () =>
    (innerHeight +
    (innerWidth > 749 ? innerWidth * 0.5 - 80 : innerWidth - 80) / 3 * 2 + 300)
      // document
      //   .querySelector(".gup-video-image-overlay-1")
      //   .getBoundingClientRect().height +
      // 600) 
    *
    -1,
  scrollTrigger: {
    start: 0,
    end: innerHeight + 1500,
    scrub: 0,
  },
});
gsap.to(".gup-video-image-overlay-2", {
  y: 
    // () =>
    (innerHeight +
     (innerWidth > 749 ? innerWidth * 0.5 - 80 - 180 : innerWidth - 80) / 3 * 2 + 300)
      // document
      //   .querySelector(".gup-video-image-overlay-2")
      //   .getBoundingClientRect().height +
      // 400) 
  *
    -1,
  scrollTrigger: {
    start: 200 + (innerWidth > 1400 ? 400 : 0),
    end: innerHeight + 3000,
    scrub: 0,
  },
});
gsap.to(".gup-video-image-overlay-3", {
  y: 
    // () =>
    (innerHeight +
     (innerWidth > 749 ? innerWidth * 0.5 - 80 - 140 : innerWidth - 160) / 2 * 3 + 300)
      // document
      //   .querySelector(".gup-video-image-overlay-3")
      //   .getBoundingClientRect().height +
      // 800) 
  *
    -1,
  scrollTrigger: {
    start: 600 + (innerWidth > 1400 || innerWidth < 750 ? 200 : 0),
    end: innerHeight + 2400,
    scrub: 0,
  },
});
// gsap.to(".gup-video-image-overlay-4 img", {
//   maxHeight: "0%",
//   scrollTrigger: {
//     start: innerHeight + 600,
//     end: innerHeight + 700,
//     scrub: 0,
//   },
// });
gsap.to(".gup-video-image-overlay-box", {
  // opacity: 1,
  visibility: "visible",
  scrollTrigger: {
    start: innerHeight + 750,
    end: innerHeight + 900,
    scrub: 0,
  },
});
// gsap.to(".gup-video-image-overlay-4", {
//   opacity: 1,
//   scrollTrigger: {
//     start: innerHeight + 750,
//     end: innerHeight + 900,
//     scrub: 0,
//   },
// });
gsap.fromTo(
  ".gup-video-image-overlay-4",
  {
    yPercent: 0,
  },
  {
    yPercent: -100,
    pointerEvents: "auto",
    ease: "none",
    scrollTrigger: {
      start: innerHeight + 1000,
      end: innerHeight + 2000 - (innerWidth > 749 ? 0 : 500),
      scrub: 0,
      // snap: 0.01,
      // onUpdate: ({ progress }) => {
      //   if (progress >= 0) {
      //     document.querySelector(
      //       ".gup-video-image-overlay-4"
      //     ).style.justifyContent = "end";
      //     document.querySelector(
      //       ".gup-video-image-overlay-4 img"
      //     ).style.objectPosition = "top";
      //   }
      // },
    },
  }
);
gsap.fromTo(
  ".gup-video-image-overlay-4",
  {
    yPercent: -100,
  },
  {
    yPercent: -150,
    ease: "none",
    immediateRender: false,
    scrollTrigger: {
      start: innerHeight + 2100 - (innerWidth > 749 ? 0 : 500),
      end: innerHeight + 3100 - (innerWidth > 749 ? 0 : 1000),
      scrub: 0,
      // snap: 0.01,
      // onUpdate: ({ progress }) => {
      //   if (progress >= 0) {
      //     document.querySelector(
      //       ".gup-video-image-overlay-4"
      //     ).style.justifyContent = "start";
      //     document.querySelector(
      //       ".gup-video-image-overlay-4 img"
      //     ).style.objectPosition = "center";
      //   }
      // },
    },
  }
);
// gsap.fromTo(
//   ".gup-video-image-overlay-4 img",
//   {
//     maxHeight: "0%",
//   },
//   {
//     maxHeight: "100%",
//     pointerEvents: "auto",
//     ease: "none",
//     scrollTrigger: {
//       start: innerHeight + 1000,
//       end: innerHeight + 2000,
//       scrub: 0,
//       // snap: 0.01,
//       onUpdate: ({ progress }) => {
//         if (progress >= 0) {
//           document.querySelector(
//             ".gup-video-image-overlay-4"
//           ).style.justifyContent = "end";
//           document.querySelector(
//             ".gup-video-image-overlay-4 img"
//           ).style.objectPosition = "top";
//         }
//       },
//     },
//   }
// );
// gsap.fromTo(
//   ".gup-video-image-overlay-4 img",
//   {
//     maxHeight: "100%",
//   },
//   {
//     maxHeight: "0%",
//     ease: "none",
//     immediateRender: false,
//     scrollTrigger: {
//       start: innerHeight + 2100,
//       end: innerHeight + 3100,
//       scrub: 0,
//       // snap: 0.01,
//       onUpdate: ({ progress }) => {
//         if (progress >= 0) {
//           document.querySelector(
//             ".gup-video-image-overlay-4"
//           ).style.justifyContent = "start";
//           document.querySelector(
//             ".gup-video-image-overlay-4 img"
//           ).style.objectPosition = "center";
//         }
//       },
//     },
//   }
// );
// gsap.to(".gup-video-image-overlay-4 .gup-caption", {
//   opacity: 0,
//   scrollTrigger: {
//     start: innerHeight + 2000,
//     end: innerHeight + 2100,
//     scrub: 0,
//   },
// });
// gsap.to(".gup-video-image-overlay-5 img", {
//   maxHeight: "0%",
//   scrollTrigger: {
//     start: innerHeight + 1650,
//     end: innerHeight + 1750,
//     scrub: 0,
//   },
// });
// gsap.to(".gup-video-image-overlay-5", {
//   opacity: 1,
//   scrollTrigger: {
//     start: innerHeight + 1850,
//     end: innerHeight + 2000,
//     scrub: 0,
//   },
// });
gsap.fromTo(
  ".gup-video-image-overlay-5",
  {
    yPercent: 0,
  },
  {
    yPercent: -100,
    pointerEvents: "auto",
    ease: "none",
    scrollTrigger: {
      start: innerHeight + 2100 - (innerWidth > 749 ? 0 : 500),
      end: innerHeight + 3100 - (innerWidth > 749 ? 0 : 1000),
      scrub: 0,
      // snap: 0.01,
      // onUpdate: ({ progress }) => {
      //   if (progress >= 0) {
      //     document.querySelector(
      //       ".gup-video-image-overlay-5"
      //     ).style.justifyContent = "end";
      //     document.querySelector(
      //       ".gup-video-image-overlay-5 img"
      //     ).style.objectPosition = "top";
      //   }
      // },
    },
  }
);
gsap.fromTo(
  ".gup-video-image-overlay-5",
  {
    yPercent: -100,
  },
  {
    yPercent: -150,
    ease: "none",
    immediateRender: false,
    scrollTrigger: {
      start: innerHeight + 3200 - (innerWidth > 749 ? 0 : 1000),
      end: innerHeight + 4200 - (innerWidth > 749 ? 0 : 1500),
      scrub: 0,
      // snap: 0.01,
      // onUpdate: ({ progress }) => {
      //   if (progress >= 0) {
      //     document.querySelector(
      //       ".gup-video-image-overlay-5"
      //     ).style.justifyContent = "start";
      //     document.querySelector(
      //       ".gup-video-image-overlay-5 img"
      //     ).style.objectPosition = "center";
      //   }
      // },
    },
  }
);
// gsap.fromTo(
//   ".gup-video-image-overlay-5 img",
//   {
//     maxHeight: "0%",
//   },
//   {
//     maxHeight: "100%",
//     pointerEvents: "auto",
//     ease: "none",
//     scrollTrigger: {
//       start: innerHeight + 2100,
//       end: innerHeight + 3100,
//       scrub: 0,
//       // snap: 0.01,
//       onUpdate: ({ progress }) => {
//         if (progress >= 0) {
//           document.querySelector(
//             ".gup-video-image-overlay-5"
//           ).style.justifyContent = "end";
//           document.querySelector(
//             ".gup-video-image-overlay-5 img"
//           ).style.objectPosition = "top";
//         }
//       },
//     },
//   }
// );
// gsap.fromTo(
//   ".gup-video-image-overlay-5 img",
//   {
//     maxHeight: "100%",
//   },
//   {
//     maxHeight: "0%",
//     ease: "none",
//     scrollTrigger: {
//       start: innerHeight + 3200,
//       end: innerHeight + 4200,
//       scrub: 0,
//       // snap: 0.01,
//       onUpdate: ({ progress }) => {
//         if (progress >= 0) {
//           document.querySelector(
//             ".gup-video-image-overlay-5"
//           ).style.justifyContent = "start";
//           document.querySelector(
//             ".gup-video-image-overlay-5 img"
//           ).style.objectPosition = "center";
//         }
//       },
//     },
//   }
// );
// gsap.to(".gup-video-image-overlay-5 .gup-caption", {
//   opacity: 0,
//   scrollTrigger: {
//     start: innerHeight + 3100,
//     end: innerHeight + 3200,
//     scrub: 0,
//   },
// });
// gsap.to(".gup-video-image-overlay-6 img", {
//   maxHeight: "0%",
//   scrollTrigger: {
//     start: innerHeight + 1750,
//     end: innerHeight + 2850,
//     scrub: 0,
//   },
// });
// gsap.to(".gup-video-image-overlay-6", {
//   opacity: 1,
//   scrollTrigger: {
//     start: innerHeight + 2950,
//     end: innerHeight + 3100,
//     scrub: 0,
//   },
// });
gsap.fromTo(
  ".gup-video-image-overlay-6",
  {
    yPercent: 0,
  },
  {
    yPercent: -100,
    pointerEvents: "auto",
    ease: "none",
    scrollTrigger: {
      start: innerHeight + 3200 - (innerWidth > 749 ? 0 : 1000),
      end: innerHeight + 4200 - (innerWidth > 749 ? 0 : 1500),
      scrub: 0,
      // snap: 0.01,
      // onUpdate: ({ progress }) => {
      //   if (progress >= 0) {
      //     document.querySelector(
      //       ".gup-video-image-overlay-6"
      //     ).style.justifyContent = "end";
      //     document.querySelector(
      //       ".gup-video-image-overlay-6 img"
      //     ).style.objectPosition = "top";
      //   }
      // },
    },
  }
);
gsap.fromTo(
  ".gup-video-image-overlay-6",
  {
    yPercent: -100,
  },
  {
    yPercent: -200,
    ease: "none",
    immediateRender: false,
    scrollTrigger: {
      start: innerHeight + 4300 - (innerWidth > 749 ? 0 : 1500),
      end: innerHeight + 5300 - (innerWidth > 749 ? 0 : 2000),
      scrub: 0,
      // snap: 0.01,
      // onUpdate: ({ progress }) => {
      //   if (progress >= 0) {
      //     document.querySelector(
      //       ".gup-video-image-overlay-6"
      //     ).style.justifyContent = "start";
      //     document.querySelector(
      //       ".gup-video-image-overlay-6 img"
      //     ).style.objectPosition = "50% 90%";
      //   }
      // },
    },
  }
);
gsap.fromTo(
  ".gup-video-image-overlay-4",
  {
    yPercent: -150,
  },
  {
    yPercent: -200,
    ease: "none",
    immediateRender: false,
    scrollTrigger: {
      start: innerHeight + 4400 - (innerWidth > 749 ? 0 : 1500),
      end: innerHeight + 5200 - (innerWidth > 749 ? 0 : 2000),
      scrub: 0,
      // snap: 0.01,
      // onUpdate: ({ progress }) => {
      //   if (progress >= 0) {
      //     document.querySelector(
      //       ".gup-video-image-overlay-6"
      //     ).style.justifyContent = "start";
      //     document.querySelector(
      //       ".gup-video-image-overlay-6 img"
      //     ).style.objectPosition = "50% 90%";
      //   }
      // },
    },
  }
);
gsap.fromTo(
  ".gup-video-image-overlay-5",
  {
    yPercent: -150,
  },
  {
    yPercent: -200,
    ease: "none",
    immediateRender: false,
    scrollTrigger: {
      start: innerHeight + 4400 - (innerWidth > 749 ? 0 : 1500),
      end: innerHeight + 5200 - (innerWidth > 749 ? 0 : 2000),
      scrub: 0,
      // snap: 0.01,
      // onUpdate: ({ progress }) => {
      //   if (progress >= 0) {
      //     document.querySelector(
      //       ".gup-video-image-overlay-6"
      //     ).style.justifyContent = "start";
      //     document.querySelector(
      //       ".gup-video-image-overlay-6 img"
      //     ).style.objectPosition = "50% 90%";
      //   }
      // },
    },
  }
);
// gsap.fromTo(
//   ".gup-video-image-overlay-box",
//   {
//     yPercent: -50,
//   },
//   {
//     yPercent: -150,
//     ease: "none",
//     immediateRender: false,
//     scrollTrigger: {
//       start: innerHeight + 4300 - (innerWidth > 749 ? 0 : 1500),
//       end: innerHeight + 5300 - (innerWidth > 749 ? 0 : 2000),
//       scrub: 0,
//       // snap: 0.01,
//       // onUpdate: ({ progress }) => {
//       //   if (progress >= 0) {
//       //     document.querySelector(
//       //       ".gup-video-image-overlay-6"
//       //     ).style.justifyContent = "start";
//       //     document.querySelector(
//       //       ".gup-video-image-overlay-6 img"
//       //     ).style.objectPosition = "50% 90%";
//       //   }
//       // },
//     },
//   }
// );
// gsap.fromTo(
//   ".gup-video-image-overlay-6 img",
//   {
//     maxHeight: "0%",
//   },
//   {
//     maxHeight: "100%",
//     pointerEvents: "auto",
//     ease: "none",
//     scrollTrigger: {
//       start: innerHeight + 3200,
//       end: innerHeight + 4200,
//       scrub: 0,
//       // snap: 0.01,
//       onUpdate: ({ progress }) => {
//         if (progress >= 0) {
//           document.querySelector(
//             ".gup-video-image-overlay-6"
//           ).style.justifyContent = "end";
//           document.querySelector(
//             ".gup-video-image-overlay-6 img"
//           ).style.objectPosition = "top";
//         }
//       },
//     },
//   }
// );
// gsap.fromTo(
//   ".gup-video-image-overlay-6 img",
//   {
//     maxHeight: "100%",
//   },
//   {
//     maxHeight: "0%",
//     ease: "none",
//     scrollTrigger: {
//       start: innerHeight + 4300,
//       end: innerHeight + 5300,
//       scrub: 0,
//       // snap: 0.01,
//       onUpdate: ({ progress }) => {
//         if (progress >= 0) {
//           document.querySelector(
//             ".gup-video-image-overlay-6"
//           ).style.justifyContent = "start";
//           document.querySelector(
//             ".gup-video-image-overlay-6 img"
//           ).style.objectPosition = "50% 90%";
//         }
//       },
//     },
//   }
// );
// gsap.to(".gup-video-image-overlay-6 .gup-caption", {
//   opacity: 0,
//   scrollTrigger: {
//     start: innerHeight + 4200,
//     end: innerHeight + 4300,
//     scrub: 0,
//   },
// });
// gsap.to(".gup-video-image-overlay-7", {
//     display: "flex",
//     opacity: 1,
//     scrollTrigger: {
//       start: innerHeight + 4100,
//       end: innerHeight + 4125,
//       scrub: 0,
//     },
//   }
// );
gsap.fromTo(".video-banner__wrapper", {
  position: "fixed",
  top: 0,
}, {
    position: "relative",
    top: innerHeight + 5500 - (innerWidth > 749 ? 0 : 1500 + 124),
    duration: 0,
    immediateRender: false,
    scrollTrigger: {
      start: innerHeight + 5500 - (innerWidth > 749 ? 0 : 1500 - 124),
      toggleActions: "play none none reverse"
    },
  }
);
// gsap.fromTo(".video-banner__wrapper", {
//   yPercent: 0
// }, {
//     yPercent: -100,
//     scrollTrigger: {
//       start: innerHeight + 11000,
//       end: innerHeight * 2 + 11000,
//       toggleActions: "play none none reverse",
//       scrub: 0,
//     },
//   }
// );
if(innerWidth > 749) gsap.fromTo(".video-banner__wrapper video", {
  scale: 1.2,
  yPercent: -5,
}, {
    yPercent: 10,
    scrollTrigger: {
      start: 0,
      end: innerHeight + 5500 - (innerWidth > 749 ? 0 : 1624),
      // toggleActions: "play pause resume reverse",
      scrub: 0,
    },
  }
);
if(innerWidth > 749) gsap.fromTo(".video-banner__wrapper video", {
  scale: 1.2,
  yPercent: 10,
}, {
    yPercent: 15,
    immediateRender: false,
    scrollTrigger: {
      start: innerHeight + 5500 - (innerWidth > 749 ? 0 : 1624),
      end: innerHeight * 2 + 5500 - (innerWidth > 749 ? 0 : 1624),
      // toggleActions: "play pause resume reverse",
      scrub: 0,
    },
  }
);
// gsap.fromTo(".gup-video-overlay-copy.gup-bottom.gup-left", {
//   position: "fixed",
//   zIndex: 20,
// }, {
//     position: "absolute",
//     zIndex: 3,
//     duration: 0,
//     immediateRender: false,
//     scrollTrigger: {
//       start: innerHeight + 5500,
//       toggleActions: "play none none reverse"
//     },
//   }
// );
// gsap.fromTo(".gup-video-overlay-copy.gup-bottom.gup-right", {
//   position: "fixed",
//   zIndex: 20,
// }, {
//     position: "absolute",
//     zIndex: 3,
//     duration: 0,
//     immediateRender: false,
//     scrollTrigger: {
//       start: innerHeight + 5500,
//       toggleActions: "play none none reverse"
//     },
//   }
// );
// gsap.fromTo(".gup-video-overlay-copy.gup-sticky-copy-1", {
//     position: "fixed",
// }, {
//     position: "absolute",
//     bottom: "calc(30vh + 13px + 48px - 28px)",
//     top: "",
//     transform: "translateX(0px)",
//     duration: 0,
//     immediateRender: false,
//     scrollTrigger: {
//       start: innerHeight * 0.2 + innerHeight + 5500,
//       toggleActions: "play none none reverse"
//     },
//   }
// );
gsap.fromTo(".gup-video-overlay-copy.gup-sticky-copy-2", {
    position: "fixed",
    transform: "translateY(-50%)",
}, {
    position: "absolute",
    bottom: "50vh",
    // top: document.querySelector(".gup-video-overlay-copy.gup-sticky-copy-2").getBoundingClientRect().y - document.querySelector(".gup-video-overlay-copy.gup-sticky-copy-2").parentElement.getBoundingClientRect().y,
    top: "unset",
    // transform: "translateY(0%)",
    transform: "translateY(50%)",
    duration: 0,
    immediateRender: false,
    scrollTrigger: {
      start: innerHeight + 5500 - (innerWidth > 749 ? 0 : 1624),
      toggleActions: "play none none reverse"
    },
  }
);
// gsap.fromTo(".gup-video-image-overlay-7", {
//     position: "fixed",
//     zIndex: 4,
// }, {
//     position: "absolute",
//     zIndex: 101,
//     bottom: "calc(30vh - 50vw + 5rem + 100px)",
//     top: "unset",
//     transform: "translateX(-50%)",
//     duration: 0,
//     immediateRender: false,
//     scrollTrigger: {
//       start: innerHeight * 0.2 + innerHeight + 5500,
//       toggleActions: "play none none reverse"
//     },
//   }
// );
// gsap.fromTo(".gup-video-overlay-copy.gup-video-shop-now", {
//     position: "absolute",
// }, {
//     position: "fixed",
//     bottom: "25vh",
//     duration: 0,
//     immediateRender: false,
//     scrollTrigger: {
//       start: innerHeight + 5500,
//       // start: innerHeight + 5500 + innerHeight * 0.25 - 64,
//       toggleActions: "play none none reverse"
//     },
//   }
// );
// gsap.fromTo(".gup-video-overlay-copy.gup-bottom.gup-left", {
//     position: "absolute",
// }, {
//     position: "fixed",
//     bottom: "calc(50vh - 30px)",
//     duration: 0,
//     immediateRender: false,
//     scrollTrigger: {
//       start: innerHeight + 5500,
//       toggleActions: "play none none reverse"
//     },
//   }
// );
// gsap.fromTo(".gup-video-overlay-copy.gup-bottom.gup-right", {
//     position: "absolute",
// }, {
//     position: "fixed",
//     bottom: "calc(50vh - 30px)",
//     duration: 0,
//     immediateRender: false,
//     scrollTrigger: {
//       start: innerHeight + 5500,
//       toggleActions: "play none none reverse"
//     },
//   }
// );
gsap.fromTo(".gup-video-overlay-copy", {
    opacity: 1,
}, {
    opacity: 0,
    pointerEvents: "none",
    immediateRender: false,
    scrollTrigger: {
      start: innerHeight + 5500 + innerHeight * 0.5 - (innerWidth > 749 ? 0 : 1624),
      end: innerHeight + 5500 + innerHeight * 0.75 - (innerWidth > 749 ? 0 : 1624),
      toggleActions: "play none none reverse",
      // scrub: 0,
    },
  }
);
// gsap.fromTo(".gup-home-video-left-copy-continued", {
//     opacity: 0,
// }, {
//     opacity: 1,
//     pointerEvents: "none",
//     immediateRender: false,
//     scrollTrigger: {
//       start: innerHeight + 5500 + innerHeight * 0.5 - 94,
//       end: innerHeight + 5500 + innerHeight * 0.5 - 94 + 1,
//       toggleActions: "play none none reverse",
//       scrub: 0,
//     },
//   }
// );
// gsap.fromTo(".gup-home-image-1-copy--color-left", {
//     opacity: 0,
//     pointerEvents: "none",
// }, {
//     opacity: 0.45,
//     pointerEvents: "auto",
//     immediateRender: false,
//     scrollTrigger: {
//       start: innerHeight + 5500 + innerHeight * 0.5 - 94,
//       end: innerHeight + 5500 + innerHeight * 0.75 - 94,
//       toggleActions: "play none none reverse",
//       scrub: 0,
//     },
//   }
// );
// gsap.fromTo(".gup-home-image-1-copy--color-right", {
//     opacity: 0,
//     pointerEvents: "none",
// }, {
//     opacity: 0.45,
//     pointerEvents: "auto",
//     immediateRender: false,
//     scrollTrigger: {
//       start: innerHeight + 5500 + innerHeight * 0.5 - 94,
//       end: innerHeight + 5500 + innerHeight * 0.75 - 94,
//       toggleActions: "play none none reverse",
//       scrub: 0,
//     },
//   }
// );
// gsap.fromTo(".gup-home-video-right-copy-continued", {
//     opacity: 0,
// }, {
//     opacity: 1,
//     pointerEvents: "none",
//     immediateRender: false,
//     scrollTrigger: {
//       start: innerHeight + 5500 + innerHeight * 0.5 - 94,
//       end: innerHeight + 5500 + innerHeight * 0.5 - 94 + 1,
//       toggleActions: "play none none reverse",
//       scrub: 0,
//     },
//   }
// );
gsap.to(".gup-home-image-1-mask", {
    background: "rgba(0,0,0,0)",
    backdropFilter: "blur(0px)",
    scrollTrigger: {
      start: innerHeight + 5500 + innerHeight * 0.2 - (innerWidth > 749 ? 0 : 1624),
      end: innerHeight + 5500 + innerHeight * 0.8 - (innerWidth > 749 ? 0 : 1624),
      // toggleActions: "play pause resume reverse",
      scrub: 0,
    },
  }
);
// gsap.to(".gup-home-image-1", {
//     filter: "blur(0px)",
//     scrollTrigger: {
//       start: innerHeight + 5500,
//       end: innerHeight + 5500 + innerHeight * 0.8,
//       toggleActions: "play reset reset reverse",
//       scrub: 0,
//     },
//   }
// );
if(innerWidth > 749) gsap.fromTo(".gup-home-image-1-wrapper", {
    position: "fixed",
    top: 0,
    height: "100%"
}, {
    position: "relative",
    top: 0,
    height: innerWidth > 749 ? "auto" : "100vh",
    duration: 0,
    immediateRender: false,
    scrollTrigger: {
      start: innerHeight + 5500 + innerHeight - (innerWidth > 749 ? 0 : 1624),
      toggleActions: "play none none reverse",
    },
  }
);
// gsap.fromTo(".gup-home-image-1-shop-now", {
//   position: "fixed",
//   bottom: "4rem",
//   top: "unset",
// }, {
//     position: "absolute",
//     top: "100%",
//     bottom: "unset",
//     duration: 0,
//     immediateRender: false,
//     scrollTrigger: {
//       trigger: "main > section:last-child",
//       start: "top bottom+=124",
//       toggleActions: "play none none reverse",
//       scrub: 0,
//       onToggle: () => {
//         const e = document.querySelector(".gup-home-image-1-shop-now");
//         if(e) {
//           document.querySelector("main > section:last-child").style.position = "relative";
//           document.querySelector("main > section:last-child").append(e);
//         };
//       }
//     },
//   }
// );
gsap.fromTo(".gup-home-image-1-shop-now", {
  opacity: 0,
  position: "fixed",
  bottom: "4rem",
  top: "unset",
}, {
    opacity: 1,
    position: "fixed",
    bottom: "4rem",
    top: "unset",
    pointerEvents: "auto",
    immediateRender: false,
    scrollTrigger: {
      start: innerHeight + 5500 + innerHeight * 0.25 - (innerWidth > 749 ? 0 : 1624),
      end: innerHeight + 5500 + innerHeight * 0.25 + 1 - (innerWidth > 749 ? 0 : 1624),
      // toggleActions: "play none none reverse",
      scrub: 0,
    },
  }
);
gsap.fromTo(".gup-home-image-1-main-copy-1", {
  filter: "blur(15px)"
}, {
    filter: "blur(0px)",
    scrollTrigger: {
      // trigger: ".gup-home-image-1-main-copy-1",
      // start: "top bottom-=20vh",
      // end: "top center",
      start: innerHeight + 5500 + innerHeight * (innerWidth > 749 ? 0.95 : 0.3) - (innerWidth > 749 ? 0 : 1624),
      toggleActions: "play none none reset",
    },
  }
);
gsap.fromTo(".gup-home-image-1-main-copy-2", {
  filter: "blur(15px)"
}, {
    filter: "blur(0px)",
    scrollTrigger: {
      // trigger: ".gup-home-image-1-main-copy-2",
      // start: "top bottom-=25vh",
      // end: "top center",
      start: innerHeight + 5500 + innerHeight * (innerWidth > 749 ? 0.9 : 0.4) + innerWidth * 0.3 - (innerWidth > 749 ? 0 : 1624),
      toggleActions: "play none none reset",
    },
  }
);

if(innerWidth > 749) gsap.fromTo(".gup-home-image-1-names", {
    position: "absolute",
    // top: "116vw",
    bottom: "33vw",
    letterSpacing: 0,
    color: "#6D645B",
}, {
    position: "fixed",
    top: "50vh",
    yPercent: -100,
    letterSpacing: 0,
    color: "#6D645B",
    duration: 0,
    immediateRender: false,
    scrollTrigger: {
      // trigger: ".gup-home-image-1-names",
      // start: "center center",
      start: innerHeight * 2 + 5500 + innerWidth / 2 * 3 - innerHeight * 0.5 - innerWidth * 0.33,
      toggleActions: "play none none reset",
      onToggle: () => {
        const e = document.querySelector(".gup-home-image-1-names");
        if(e) {
          // document.querySelector("main#MainContent").append(e);
          document.querySelector(".gup-home-transition-block-1").append(e);
          e.style.zIndex = 1;
        };
      }
    },
  }
); 
if(innerWidth > 749) gsap.fromTo(".gup-home-image-1-names", {
    filter: "blur(0px)",
    // opcacity: 0.2,
    // zIndex: 3,
}, {
    filter: "blur(8px)",
    // opcacity: 1,
    // zIndex: 1,
    // duration: 0,
    ease: "power1.out",
    immediateRender: false,
    scrollTrigger: {
      // trigger: ".gup-home-image-1-names",
      // start: "center center",
      start: innerHeight * 2 + 5500 + innerWidth / 2 * 3 - innerHeight + 200,
      // start: innerHeight * 2 + 5500 + innerWidth / 2 * 3 / 2,
      end: innerHeight * 2 + 5500 + innerWidth / 2 * 3 - innerHeight + 800,
      // toggleActions: "play none none reset",
      // onToggle: () => {
      //   const e = document.querySelector(".gup-home-image-1-names");
      //   if(e && document.querySelector(".gup-home-transition-block-1")) {
      //     // document.querySelector("main#MainContent").append(e);
      //     document.querySelector(".gup-home-transition-block-1").append(e);
      //   };
      // },
      scrub: 0,
    },
  }
);
if(innerWidth > 749) gsap.fromTo(".gup-home-image-1-names", {
  filter: "blur(8px)",
  opacity: 1,
}, {
    filter: "blur(0px)",
    opacity: 0.25,
    immediateRender: false,
    scrollTrigger: {
      trigger: ".gup-home-transition-block-1",
      start: innerWidth > 749 ? "bottom bottom" : "bottom bottom+=25vh",
      end: innerWidth > 749 ? "bottom center" : "bottom center+=25vh",
      // start: innerHeight * 2 + 5500 + innerWidth / 2 * 3 - innerHeight + 1000,
      // end: innerHeight * 2 + 5500 + innerWidth / 2 * 3 - innerHeight + 1400,
      // toggleActions: "play none none reset",
      scrub: 0,
    },
  }
);
gsap.to("header", {
//   filter: "blur(5px)",
//   opacity: 1,
// }, {
    backdropFilter: "blur(20px)",
    immediateRender: false,
    scrollTrigger: {
      trigger: ".gup-home-transition-block-1",
      start: "top top",
      end: "center center",
      // start: innerHeight * 2 + 5500 + innerWidth / 2 * 3 - innerHeight + 1000,
      // end: innerHeight * 2 + 5500 + innerWidth / 2 * 3 - innerHeight + 1400,
      toggleActions: "play none none reset",
      // scrub: 0,
    },
  }
);
gsap.to(".brand-nav-container img", {
//   filter: "blur(5px)",
//   opacity: 1,
// }, {
    filter: "invert(1)",
    immediateRender: false,
    scrollTrigger: {
      trigger: ".gup-home-transition-block-1",
      start: "top top",
      end: "center center",
      // start: innerHeight * 2 + 5500 + innerWidth / 2 * 3 - innerHeight + 1000,
      // end: innerHeight * 2 + 5500 + innerWidth / 2 * 3 - innerHeight + 1400,
      toggleActions: "play none none reset",
      // scrub: 0,
    },
  }
);
gsap.to("header .header-heading-logo-wrapper.gup-header-logo img", {
//   filter: "blur(5px)",
//   opacity: 1,
// }, {
    filter: "invert(0)",
    immediateRender: false,
    scrollTrigger: {
      trigger: ".gup-home-transition-block-1",
      start: "top top",
      end: "center center",
      // start: innerHeight * 2 + 5500 + innerWidth / 2 * 3 - innerHeight + 1000,
      // end: innerHeight * 2 + 5500 + innerWidth / 2 * 3 - innerHeight + 1400,
      toggleActions: "play none none reset",
      // scrub: 0,
    },
  }
);
gsap.to("header a.link", {
//   filter: "blur(5px)",
//   opacity: 1,
// }, {
    color: "#111111",
    immediateRender: false,
    scrollTrigger: {
      trigger: ".gup-home-transition-block-1",
      start: "top top",
      end: "center center",
      // start: innerHeight * 2 + 5500 + innerWidth / 2 * 3 - innerHeight + 1000,
      // end: innerHeight * 2 + 5500 + innerWidth / 2 * 3 - innerHeight + 1400,
      toggleActions: "play none none reset",
      // scrub: 0,
    },
  }
);
gsap.to(".brand-nav-container .chev", {
//   filter: "blur(5px)",
//   opacity: 1,
// }, {
    color: "white",
    immediateRender: false,
    scrollTrigger: {
      trigger: ".gup-home-transition-block-1",
      start: "top top",
      end: "center center",
      // start: innerHeight * 2 + 5500 + innerWidth / 2 * 3 - innerHeight + 1000,
      // end: innerHeight * 2 + 5500 + innerWidth / 2 * 3 - innerHeight + 1400,
      toggleActions: "play none none reset",
      // scrub: 0,
    },
  }
);
gsap.to(".brand-nav-container a + div", {
//   filter: "blur(5px)",
//   opacity: 1,
// }, {
    color: "white",
    immediateRender: false,
    scrollTrigger: {
      trigger: ".gup-home-transition-block-1",
      start: "top top",
      end: "center center",
      // start: innerHeight * 2 + 5500 + innerWidth / 2 * 3 - innerHeight + 1000,
      // end: innerHeight * 2 + 5500 + innerWidth / 2 * 3 - innerHeight + 1400,
      toggleActions: "play none none reset",
      // scrub: 0,
    },
  }
);
if(innerWidth > 749) gsap.fromTo(".gup-home-image-1-names", {
  filter: "blur(100px)",
  opacity: 0,
}, {
    filter: "blur(0px)",
    opacity: 1,
    duration: 1,
    scrollTrigger: {
      // trigger: ".gup-home-image-1-names",
      // start: "top bottom-=30vh",
      // end: "top center",
      start: innerHeight * 2 + 5500 + innerWidth / 2 * 3 - innerHeight * 0.5 - innerWidth * 0.33 - innerHeight * 0.75,
      // end: innerHeight * 2 + 5500 + innerWidth / 2 * 3 - innerHeight * 0.5 - innerWidth * 0.33,
      toggleActions: "play none none reverse",
    },
  }
);
// gsap.fromTo(".gup-home-image-1-names", {
//   filter: "brightness(1) blur(100px)",
//   opacity: 1,
// }, {
//     filter: "brightness(0)",
//     opacity: 0.15,
//     immediateRender: false,
//     scrollTrigger: {
//       trigger: ".gup-home-transition-block-1",
//       start: "top center",
//       end: "bottom bottom",
//       toggleActions: "play none none reverse",
//       scrub: 0,
//     },
//   }
// );
if(innerWidth > 749) gsap.fromTo(".gup-home-image-1-names", {
    position: "fixed",
    top: "116vw",
    yPercent: 0,
}, {
    position: "absolute",
    top: "unset",
    bottom: "100px",
    yPercent: 0,
    duration: 0,
    immediateRender: false,
    scrollTrigger: {
      trigger: ".gup-home-transition-block-1",
      start: "bottom center+=100",
      toggleActions: "play none none reset",
      onToggle: () => {
        const e = document.querySelector(".gup-home-image-1-names");
        if(e) {
          document.querySelector(".gup-home-transition-block-1").append(e);
        };
      }
    },
  }
);
// gsap.fromTo(".gup-lifestyle-copy.gup-home-image-1-copy--color-left", {
//     opacity: 0.45,
// }, {
//     opacity: 0,
//     immediateRender: false,
//     scrollTrigger: {
//       trigger: ".gup-home-image-1-names",
//       start: "top center",
//       end: "center center",
//       toggleActions: "play none none reverse",
//       scrub: 0,
//     },
//   }
// );
// gsap.fromTo(".gup-lifestyle-copy.gup-home-image-1-copy--color-right", {
//     opacity: 0.45,
// }, {
//     opacity: 0,
//     immediateRender: false,
//     scrollTrigger: {
//       trigger: ".gup-home-image-1-names",
//       start: "top center",
//       end: "center center",
//       toggleActions: "play none none reverse",
//       scrub: 0,
//     },
//   }
// );
// gsap.fromTo(".gup-lifestyle-copy.gup-home-video-left-copy-continued", {
//     opacity: 1,
// }, {
//     opacity: 0,
//     immediateRender: false,
//     scrollTrigger: {
//       trigger: ".gup-home-image-1-names",
//       start: "top center",
//       end: "center center",
//       toggleActions: "play none none reverse",
//       scrub: 0,
//     },
//   }
// );
// gsap.fromTo(".gup-lifestyle-copy.gup-home-video-right-copy-continued", {
//     opacity: 1,
// }, {
//     opacity: 0,
//     immediateRender: false,
//     scrollTrigger: {
//       trigger: ".gup-home-image-1-names",
//       start: "top center",
//       end: "center center",
//       toggleActions: "play none none reverse",
//       scrub: 0,
//     },
//   }
// );
gsap.fromTo(".gup-home-image-1-shop-now", {
  color: "white",
  borderColor: "white",
}, {
    color: "black",
    borderColor: "black",
    scrollTrigger: {
      trigger: ".gup-home-image-1-names",
      start: "top center",
      end: "center center",
      // toggleActions: "play none none reverse",
      scrub: 0,
    },
  }
);
gsap.fromTo(".gup-home-image-1-shop-now", {
  // opacity: 1
  position: "fixed",
}, {
  position: "absolute",
  top: document.querySelector("footer div").getBoundingClientRect().y - document.querySelector(".gup-home-image-1-shop-now").parentElement.getBoundingClientRect().y - (innerWidth > 749 ? 64 : 56) - 60 - 160,
  duration: 0,
    immediateRender: false,
    scrollTrigger: {
      trigger: "footer div",
      start: "top bottom+=160",
      // end: "bottom bottom+=100",
      toggleActions: "play none none reverse",
      // scrub: 0,
      // onToggle: () => {
      //   console.log((document.querySelector(".gup-home-image-1-shop-now").getBoundingClientRect.y - document.querySelector(".gup-home-image-1-shop-now").parentElement.getBoundingClientRect.y) + "px");
      //   document.querySelector(".gup-home-image-1-shop-now").style.top = (document.querySelector(".gup-home-image-1-shop-now").getBoundingClientRect().y - document.querySelector(".gup-home-image-1-shop-now").parentElement.getBoundingClientRect().y) + "px"
      // }
    },
  }
);
gsap.fromTo(".gup-home-image-1-shop-now", {
  position: "absolute",
}, {
  position: "fixed",
  bottom: innerWidth > 749 ? 64 : 56,
  duration: 0,
    immediateRender: false,
    scrollTrigger: {
      trigger: ".gup-home-image-1-shop-now",
      start: "bottom bottom+=" + innerWidth > 749 ? 63 : 55,
      // end: "bottom bottom+=100",
      toggleActions: "play none none reverse",
      // scrub: 0,
      // onToggle: () => {
      //   console.log((document.querySelector(".gup-home-image-1-shop-now").getBoundingClientRect.y - document.querySelector(".gup-home-image-1-shop-now").parentElement.getBoundingClientRect.y) + "px");
      //   document.querySelector(".gup-home-image-1-shop-now").style.top = (document.querySelector(".gup-home-image-1-shop-now").getBoundingClientRect().y - document.querySelector(".gup-home-image-1-shop-now").parentElement.getBoundingClientRect().y) + "px"
      // }
    },
  }
);
if(innerWidth > 749) gsap.fromTo(".gup-gup-home-transition-callout-1", {
    y: 0
}, {
    y: -180,
    ease: "power1.out",
    scrollTrigger: {
      trigger: ".gup-gup-home-transition-callout-1",
      start: "top bottom",
      end: "bottom top",
      // toggleActions: "play pause resume reverse",
      scrub: 0,
    },
  }
);
if(innerWidth > 749) gsap.fromTo(".gup-gup-home-transition-callout-2", {
    y: 0
}, {
    y: -150,
    ease: "power1.out",
    scrollTrigger: {
      trigger: ".gup-gup-home-transition-callout-2",
      start: "top bottom",
      end: "bottom top",
      // toggleActions: "play pause resume reverse",
      scrub: 0,
    },
  }
);










  
}
addEventListener('DOMContentLoaded', () => {
  try {
    gupLifestyleLoad();
  } catch (error) {
    let ct = 0;
    const catcher = setInterval(() => {
      if(ct >= 1000) {
        location.reload();
        clearInterval(catcher);
      }
      try {
        gupLifestyleLoad();
        clearInterval(catcher);
      } catch (error) {
        ct += 1;
      }
    }, 1000)
  }
  try {
    document.querySelector("video").style.transition = "1.5s";
    document.querySelector("video").style.filter = "blur(0px)";
  } catch (error) {
    let ct = 0;
    const catcher = setInterval(() => {
      if(ct >= 1000) {
        location.reload();
        clearInterval(catcher);
      }
      try {
        document.querySelector("video").style.transition = "1.5s";
        document.querySelector("video").style.filter = "blur(0px)";
        clearInterval(catcher);
      } catch (error) {
        ct += 1;
      }
    }, 1000)
  }
  
});